import { render, staticRenderFns } from "./RegisterKycDocuments.vue?vue&type=template&id=59bb0866&scoped=true"
import script from "./RegisterKycDocuments.vue?vue&type=script&lang=js"
export * from "./RegisterKycDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb0866",
  null
  
)

export default component.exports